import { Route, Routes } from "react-router-dom";
import PrivateRoute from "./componetns/PrivateRoute";
import PublicRoute from "./componetns/PublicRoute";
import useAuthCheck from "./hooks/useAuthCheck";
import Login from "./pages/Login";
import Projects from "./pages/Projects";
import Teams from "./pages/Teams";

export default function App() {
    return (
        <div>
            {!useAuthCheck() ? (
                "Checking Authetication..."
            ) : (
                <Routes>
                    <Route element={<PrivateRoute />}>
                        <Route path="/teams" element={<Teams />} />
                        <Route path="/projects" element={<Projects />} />
                    </Route>
                    <Route element={<PublicRoute />}>
                        <Route path="/" element={<Login />} />
                    </Route>
                </Routes>
            )}
        </div>
    );
}
